import React, { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap styles
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; // Import Bootstrap JS (for tooltips to work)
import AuthUser from '../AuthUser';
const ViewMoreDetailsforIndividualQuotes = (props) => {
  const { http, getUser } = AuthUser()
  let userdetails = getUser()
  const[individualinfo,setIndividualinfo]=useState({})
  const [indautoinfo, setIndautoinfo] = useState({})
  const [indhomeinfo, setIndhomeinfo] = useState({})
  const [indhealthinfo, setIndhealthinfo] = useState({})
  const [indindexuniinfo, setIndindexuniinfo] = useState({})
  const [indrenterinfo, setIndrenterinfo] = useState({})
  const [indunilifeinfo, setIndunilifeinfo] = useState({})
  const [indvarlifeinfo, setIndvarlifeinfo] = useState({})
  const [indtermlifeinfo, setIndtermlifeinfo] = useState({})
  const [indwholelifeinfo, setIndwholelifeinfo] = useState({})
  const [indinxhistory, setIndinxhistory] = useState({})
  const [indhealthhistory, setIndhealthhistory] = useState({})

  useEffect(() => {
    if (props.id) {
      http.get(`admin/viewIndividual/${userdetails.email}?id=${props.id}`)
        .then((response) => {
          console.log(response.data)
          setIndividualinfo(response.data.individualinfo)
          setIndautoinfo(response.data.indautoinfo)
          setIndhomeinfo(response.data.indhomeinfo)
          setIndhealthinfo(response.data.indhealthinfo)
          setIndindexuniinfo(response.data.indindexuniinfo)
          setIndrenterinfo(response.data.indrenterinfo)
          setIndunilifeinfo(response.data.indunilifeinfo)
          setIndvarlifeinfo(response.data.indvarlifeinfo)
          setIndtermlifeinfo(response.data.indtermlifeinfo)
          setIndwholelifeinfo(response.data.indwholelifeinfo)
          setIndinxhistory(response.data.indinxhistory)
          setIndhealthhistory(response.data.indhealthhistory)
        })
        .catch(function (error) {

        })
    }
  }, [props.id])

  return (
    <Container>
            <Row style={{ backgroundColor: "#E3E0EB" }} className="p-2">
              <Col sm={11} className="fw-bold">
                Personal Information
              </Col>
              <Col sm={1}>
                
              </Col>
            </Row>
            <Row className="mt-2 p-2">
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>First Name</strong>
                </p>
                <span>{individualinfo.firstname}</span>
              </Col>
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Middle Name</strong>
                </p>
                <span>{individualinfo.middlename}</span>
              </Col>
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Last Name</strong>
                </p>
                <span>{individualinfo.lastname}</span>
              </Col>
            </Row>
            <Row className="mt-2 p-2">
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Date of Birth</strong>
                </p>
                <span>{individualinfo.dateofbirth}</span>
              </Col>
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Gender</strong>
                </p>
                <span>{individualinfo.gender}</span>
              </Col>
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Social Security Number (SSN)</strong>
                </p>
                <span>{individualinfo.ssnno}</span>
              </Col>
            </Row>

            <Row style={{ backgroundColor: "#E3E0EB" }} className="p-2">
              <Col sm={11} className="fw-bold">
                Contact Information
              </Col>
              <Col sm={1}>
                
              </Col>
            </Row>

            <Row className="mt-2 p-2">
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Phone Number</strong>
                </p>
                <span>{individualinfo.phoneno}</span>
              </Col>
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Email Address</strong>
                </p>
                <span>{individualinfo.email}</span>
              </Col>
            </Row>
            <Row style={{ backgroundColor: "#E3E0EB" }} className="p-2">
              <Col sm={11} className="fw-bold">
                Address Information
              </Col>
              <Col sm={1}>
                
              </Col>
            </Row>
            <Row className="mt-2 p-2">
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Street Address</strong>
                </p>
                <span>{individualinfo.address}</span>
              </Col>
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>City</strong>
                </p>
                <span>{individualinfo.city}</span>
              </Col>
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>State</strong>
                </p>
                <span>{individualinfo.state}</span>
              </Col>
            </Row>
            <Row className="mt-2 p-2">
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>ZIP Code</strong>
                </p>
                <span>{individualinfo.zipcode}</span>
              </Col>
            </Row>

            <Row style={{ backgroundColor: "#E3E0EB" }} className="p-2">
              <Col sm={11} className="fw-bold">
                Financial Information
              </Col>
              <Col sm={1}>
                
              </Col>
            </Row>

            <Row className="mt-2 p-2">
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Annual Income</strong>
                </p>
                <span>${individualinfo.annualincome}</span>
              </Col>
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Employment Status</strong>
                </p>
                <span>{individualinfo.employmentstatus}</span>
              </Col>
              <Col sm={4}>
                <p className="p-0 m-0">
                  <strong>Occupation</strong>
                </p>
                <span>{individualinfo.occupation}</span>
              </Col>
            </Row>
            <br/>
            {indautoinfo && Object.keys(indautoinfo).length > 0 && (
              <>
                <Row style={{ backgroundColor: "#E3E0EB" }} className="p-2">
                  <Col sm={11} className="fw-bold">
                    Auto Insurance
                  </Col>
                  <Col sm={1}>
                    
                  </Col>
                </Row>

                <Row className="mt-2 p-2">
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Make</strong>
                    </p>
                    <span>{indautoinfo?.make} </span>
                  </Col>
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Model</strong>
                    </p>
                    <span>{indautoinfo?.model}</span>
                  </Col>
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Year</strong>
                    </p>
                    <span>{indautoinfo?.year}</span>
                  </Col>
                  </Row>
                  <Row className="mt-2 p-2">
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>VIN</strong>
                    </p>
                    <span>{indautoinfo?.vin} </span>
                  </Col>
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Primary Use of Vehicle</strong>
                    </p>
                    <span>{indautoinfo?.primaryuse}</span>
                  </Col>
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Insurance Company name</strong>
                    </p>
                    <span>{indautoinfo?.autoinxprovider} </span>
                  </Col>
                </Row>
                <Row className="mt-2 p-2">
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Driving History</strong>
                    </p>
                    <span>{indautoinfo?.drivinghistory} </span>
                  </Col>
                </Row>
              </>
            )}
            {indhomeinfo && Object.keys(indhomeinfo).length > 0 && (
              <>
                <Row style={{ backgroundColor: "#E3E0EB" }} className="p-2">
                  <Col sm={11} className="fw-bold">
                    Home Insurance
                  </Col>
                  <Col sm={1}>
                    
                  </Col>
                </Row>

                <Row className="mt-2 p-2">
                  <Col sm={12}>
                    <p className="p-0 m-0">
                      <strong>Property Address</strong>
                    </p>
                    <span>{indhomeinfo?.propertyaddress} </span>
                  </Col>
                </Row>
                <Row className="mt-2 p-2">
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Property Type </strong>
                    </p>
                    <span>{indhomeinfo?.propertytype}</span>
                  </Col>
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Year Built </strong>
                    </p>
                    <span>{indhomeinfo?.yearbuilt}</span>
                  </Col>
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Square Footage </strong>
                    </p>
                    <span>{indhomeinfo?.sqft}</span>
                  </Col>
                </Row>
                <Row className="mt-2 p-2">
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Home Value </strong>
                    </p>
                    <span>{indhomeinfo?.homevalue} </span>
                  </Col>
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Security Features </strong>
                    </p>
                    <span>{indhomeinfo?.features}</span>
                  </Col>
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Current Home Insurance Provider </strong>
                    </p>
                    <span>{indhomeinfo?.homeinxprovider}</span>          
                  </Col>
                </Row>
              </>
            )}
            {indhealthinfo && Object.keys(indhealthinfo).length > 0 && (
              <>
                <Row style={{ backgroundColor: "#E3E0EB" }} className="p-2">
                  <Col sm={11} className="fw-bold">
                    Health Insurance
                  </Col>
                  <Col sm={1}>
                    
                  </Col>
                </Row>

                <Row className="mt-2 p-2">
                  <Col sm={12}>
                    <p className="p-0 m-0">
                      <strong>Coverage Type </strong>
                    </p>
                    <span>{indhealthinfo?.coveragetype} </span>
                  </Col>
                  
                </Row>
                <Row className='mt-2 p-2'>
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Name </strong>
                    </p>
                    <span>{indhealthinfo?.name}</span>
                  </Col>
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Date of Birth </strong>
                    </p>
                    <span>{indhealthinfo?.dateofbirth}</span>
                  </Col>
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Relationship </strong>
                    </p>
                    <span>{indhealthinfo?.relation}</span>
                  </Col>
                </Row>
                <Row className="mt-2 p-2">
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Current Health Insurance Provider </strong>
                    </p>
                    <span>{indhealthinfo?.healthinxprovider} </span>
                  </Col>
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Primary Care Physician </strong>
                    </p>
                    <span>{indhealthinfo?.primarycare}</span>
                  </Col>
                </Row>
              </>
            )}
             {indindexuniinfo && Object.keys(indindexuniinfo).length > 0 && (
              <>
                <Row style={{ backgroundColor: "#E3E0EB" }} className="p-2">
                  <Col sm={11} className="fw-bold">
                  Indexed universal life insurance
                  </Col>
                  <Col sm={1}>
                    
                  </Col>
                </Row>

                <Row className="mt-2 p-2">
                  <Col sm={6}>
                    <p className="p-0 m-0">
                      <strong>Coverage Amount </strong>
                    </p>
                    <span>{indindexuniinfo?.coverageamount} </span>
                  </Col>
                  <Col sm={6}>
                    <p className="p-0 m-0">
                      <strong>Coverage Type </strong>
                    </p>
                    <span>{indindexuniinfo?.coveragetype}</span>
                  </Col>
                </Row><Row className='mt-2 p-2'>
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Name </strong>
                    </p>
                    <span>{indindexuniinfo?.name}</span>
                  </Col>
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Date of Birth </strong>
                    </p>
                    <span>{indindexuniinfo?.dateofbirth}</span>
                  </Col>
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Relationship </strong>
                    </p>
                    <span>{indindexuniinfo?.relation}</span>
                  </Col>
                </Row>
                <Row className="mt-2 p-2">
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Current Life Insurance Provider </strong>
                    </p>
                    <span>{indindexuniinfo?.inxprovider} </span>
                  </Col>
                </Row>
              </>
            )}
            {indrenterinfo && Object.keys(indrenterinfo).length > 0 && (
              <>
                <Row style={{ backgroundColor: "#E3E0EB" }} className="p-2">
                  <Col sm={11} className="fw-bold">
                  Renters insurance
                  </Col>
                  <Col sm={1}>
                    
                  </Col>
                </Row>

                <Row className="mt-2 p-2">
                  <Col sm={12}>
                    <p className="p-0 m-0">
                      <strong>Rented Property Address  </strong>
                    </p>
                    <span>{indrenterinfo?.propertyaddress} </span>
                  </Col>
                </Row><Row className='mt-2 p-2'>
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Property Type </strong>
                    </p>
                    <span>{indrenterinfo?.propertytype}</span>
                  </Col>
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Personal Property Value </strong>
                    </p>
                    <span>{indrenterinfo?.propertyvalue}</span>
                  </Col>
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Liability Coverage Amount </strong>
                    </p>
                    <span>{indrenterinfo?.coverageamount}</span>
                  </Col>
                </Row><Row className='mt-2 p-2'>
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Current Renters Insurance Provider </strong>
                    </p>
                    <span>{indrenterinfo?.rentersinsurance}</span>
                  </Col>
                </Row>
              </>
            )}
            {indtermlifeinfo && Object.keys(indtermlifeinfo).length > 0 && (
              <>
                <Row style={{ backgroundColor: "#E3E0EB" }} className="p-2">
                  <Col sm={11} className="fw-bold">
                  Term Life Insurance
                  </Col>
                  <Col sm={1}>
                    
                  </Col>
                </Row>

                <Row className="mt-2 p-2">
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Coverage Amount   </strong>
                    </p>
                    <span>{indtermlifeinfo?.coverageamount} </span>
                  </Col>
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Term Length </strong>
                    </p>
                    <span>{indtermlifeinfo?.termlegth}</span>
                  </Col>
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Premium Payment Frequency </strong>
                    </p>
                    <span>{indtermlifeinfo?.premiumfreq}</span>
                  </Col>
                </Row><Row className='mt-2 p-2'>
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Name </strong>
                    </p>
                    <span>{indtermlifeinfo?.name}</span>
                  </Col>
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Date of Birth </strong>
                    </p>
                    <span>{indtermlifeinfo?.dateofbirth}</span>
                  </Col>
                </Row><Row className='mt-2 p-2'>
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Relationship </strong>
                    </p>
                    <span>{indtermlifeinfo?.relation}</span>
                  </Col>
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Current Term Life Insurance Provider </strong>
                    </p>
                    <span>{indtermlifeinfo?.termlifeprovider}</span>
                  </Col>
                </Row>
              </>
            )}
            {indunilifeinfo && Object.keys(indunilifeinfo).length > 0 && (
              <>
                <Row style={{ backgroundColor: "#E3E0EB" }} className="p-2">
                  <Col sm={11} className="fw-bold">
                  Universal Life Insurance
                  </Col>
                  <Col sm={1}>
                    
                  </Col>
                </Row>

                <Row className="mt-2 p-2">
                  <Col sm={12}>
                    <p className="p-0 m-0">
                      <strong>Coverage Amount   </strong>
                    </p>
                    <span>{indunilifeinfo?.coverageamount} </span>
                  </Col>
                </Row><Row className='mt-2 p-2'>
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Premium Payment Frequency </strong>
                    </p>
                    <span>{indunilifeinfo?.paymentfreq}</span>
                  </Col>
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Cash Value Accumulation Preference </strong>
                    </p>
                    <span>{indunilifeinfo?.accumulatepref}</span>
                  </Col>
                </Row><Row className='mt-2 p-2'>
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Name </strong>
                    </p>
                    <span>{indunilifeinfo?.name}</span>
                  </Col>
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Date of Birth </strong>
                    </p>
                    <span>{indunilifeinfo?.dateofbirth}</span>
                  </Col>
                </Row><Row className='mt-2 p-2'>
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Relationship </strong>
                    </p>
                    <span>{indunilifeinfo?.relation}</span>
                  </Col>
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Current Universal life insurance provider</strong>
                    </p>
                    <span>{indunilifeinfo?.inxprovider}</span>
                  </Col>
                </Row>
              </>
            )}
            {indvarlifeinfo && Object.keys(indvarlifeinfo).length > 0 && (
              <>
                <Row style={{ backgroundColor: "#E3E0EB" }} className="p-2">
                  <Col sm={11} className="fw-bold">
                  Variable Universal Life Insurance
                  </Col>
                  <Col sm={1}>
                    
                  </Col>
                </Row>

                <Row className="mt-2 p-2">
                  <Col sm={12}>
                    <p className="p-0 m-0">
                      <strong>Coverage Amount   </strong>
                    </p>
                    <span>{indvarlifeinfo?.coverageamount} </span>
                  </Col>
                </Row><Row className='mt-2 p-2'>
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Premium Payment Frequency </strong>
                    </p>
                    <span>{indvarlifeinfo?.paymentfreq}</span>
                  </Col>
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Investment Options </strong>
                    </p>
                    <span>{indvarlifeinfo?.investmentoptions}</span>
                  </Col>
                </Row><Row className='mt-2 p-2'>
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Name </strong>
                    </p>
                    <span>{indvarlifeinfo?.name}</span>
                  </Col>
                  <Col sm={6}>
                    <p className="p-0 m-0">
                      <strong>Date of Birth </strong>
                    </p>
                    <span>{indvarlifeinfo?.dateofbirth}</span>
                  </Col>
                </Row><Row className='mt-2 p-2'>
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Relationship </strong>
                    </p>
                    <span>{indvarlifeinfo?.relation}</span>
                  </Col>
                  <Col sm={6}>
                    <p className="p-0 m-0">
                      <strong>Current Variable universal life insurance provider </strong>
                    </p>
                    <span>{indvarlifeinfo?.inxprovider}</span>
                  </Col>
                </Row>
              </>
            )}
            {indwholelifeinfo && Object.keys(indwholelifeinfo).length > 0 && (
              <>
                <Row style={{ backgroundColor: "#E3E0EB" }} className="p-2">
                  <Col sm={11} className="fw-bold">
                  Whole life insurance
                  </Col>
                  <Col sm={1}>
                    
                  </Col>
                </Row>

                <Row className="mt-2 p-2">
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Coverage Amount   </strong>
                    </p>
                    <span>{indwholelifeinfo?.coverageamount} </span>
                  </Col>
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Premium Payment Frequency </strong>
                    </p>
                    <span>{indwholelifeinfo?.paymentfreq}</span>
                  </Col>
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Cash Value Usage Preference </strong>
                    </p>
                    <span>{indwholelifeinfo?.usagepref}</span>
                  </Col>
                </Row><Row className='mt-2 p-2'>
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Name </strong>
                    </p>
                    <span>{indwholelifeinfo?.name}</span>
                  </Col>
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Date of Birth </strong>
                    </p>
                    <span>{indwholelifeinfo?.dateofbirth}</span>
                  </Col>
                </Row><Row className='mt-2 p-2'>
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Relationship </strong>
                    </p>
                    <span>{indwholelifeinfo?.relation}</span>
                  </Col>
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Current Whole life insurance provider </strong>
                    </p>
                    <span>{indwholelifeinfo?.inxprovider}</span>
                  </Col>
                </Row>
              </>
            )}
            
            {indinxhistory && Object.keys(indinxhistory).length > 0 && (
              <>
                <Row style={{ backgroundColor: "#E3E0EB" }} className="p-2">
                  <Col sm={11} className="fw-bold">
                    Insurance History
                  </Col>
                  <Col sm={1}>
                    
                  </Col>
                </Row>
                <Row className="mt-2 p-2">
                  <Col sm={12}>
                    <p className="p-0 m-0">
                      <strong>Do you have any existing life insurance?  </strong>
                    </p>
                    <span>{indinxhistory?.existinginx} </span>
                  </Col>
                </Row><Row className='mt-2 p-2'>
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Policy Number </strong>
                    </p>
                    <span>{indinxhistory?.policyno}</span>
                  </Col>
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Insurer Name </strong>
                    </p>
                    <span>{indinxhistory?.insurername}</span>
                  </Col>
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Coverage Amount  </strong>
                    </p>
                    <span>{indinxhistory?.coverageamount}</span>
                  </Col>
                </Row>
                
              </>
            )}
            {indhealthhistory && Object.keys(indhealthhistory).length > 0 && (
              <>
                <Row style={{ backgroundColor: "#E3E0EB" }} className="p-2">
                  <Col sm={11} className="fw-bold">
                    Health Information
                  </Col>
                  <Col sm={1}>
                    
                  </Col>
                </Row>
                <Row className="mt-2 p-2">
                  <Col sm={12}>
                    <p className="p-0 m-0">
                      <strong>Height  </strong>
                    </p>
                    <span>{indhealthhistory?.feet} ft, {indhealthhistory?.inches} in , {indhealthhistory?.centims} cm  </span>
                  </Col>
                </Row><Row className='mt-2 p-2'>
                  <Col sm={12}>
                    <p className="p-0 m-0">
                      <strong>Weight </strong>
                    </p>
                    <span>{indhealthhistory?.lbs} lbs, {indhealthhistory?.weightkg} kg</span>
                  </Col>
                </Row><Row className='mt-2 p-2'>
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Do you smoke or use tobacco? </strong>
                    </p>
                    <span>{indhealthhistory?.tobacco}</span>
                  </Col>
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong> List any pre-existing medical conditions </strong>
                    </p>
                    <span>{indhealthhistory?.medicalcondition}</span>
                  </Col>
                </Row><Row className='mt-2 p-2'>
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Current Medications </strong>
                    </p>
                    <span>{indhealthhistory?.currentmedications}</span>
                  </Col>
                  <Col sm={4}>
                    <p className="p-0 m-0">
                      <strong>Family Medical History </strong>
                    </p>
                    <span>{indhealthhistory?.medicalhistory}</span>
                  </Col>
                </Row>                
              </>
            )}
          </Container>


  );


};

export default ViewMoreDetailsforIndividualQuotes;